import { ui } from '@owenscorning/pcb.alpha';

import { expandRef, wrapRef } from '../../../../data';
import useReference from '../../../../hooks/use_reference';
import { apiGet } from '../../../PageBuilder/helpers/api';

let searchAbortController;

const refSearchMetadata = (startOpen, resultMapper) => ({
  startOpen,
  label: 'Enclosure',
  dataset: 'enclosures',
  set: (value, path) => {
    // TODO: handle empty/null value?
    const ref = wrapRef('Enclosure', value.id);
    expandRef(ref).then(result => resultMapper(result, path));
    return ref;
  },
  get: value => {
    const { results, error, loading } = useReference(value);
    if (loading) {
      return <i>Loading...</i>;
    }
    if (error) {
      return <span>{error}</span>;
    }
    return results;
  },
});

const mapping = {
  CtaEnclosureSet: {
    availableIn: ['www.owenscorning.com'],
    name: 'Enclosure PDP',
    meta: {
      item: ui`Form`.of({
        enclosure: ui`Search`(refSearchMetadata(false, x => x)),
      })({
        singular: 'Enclosure',
        title: 'title',
        label: 'Enclosures',
      }),
    },
    old_view: async ({ item } = {}) => expandRef(item?.enclosure),
  },
  Search: {
    name: 'Enclosure Search',
    meta: {},
    search: async ({ filter }) => {
      if (searchAbortController) searchAbortController.abort();
      searchAbortController = new AbortController();
      const res = await apiGet(
        // eslint-disable-next-line max-len
        `/api/v2/cms/sites/www.owenscorning.com/published?filter[type]=Cms::Content::Product::Enclosure&q=${filter}`,
        {
          signal: searchAbortController.signal,
        }
      );
      return res.data.map(data => ({
        id: data.content_uuid,
        ID: data.content_uuid,
        name: data.name,
        Name: data.name,
      }));
    },
    preview: result => {
      if (result.data?.[0])
        return (
          <div>
            <p>
              <b>ID:</b> {result.data[0].id}
            </p>
            <p>
              <b>Name:</b> {result.data[0].name}
            </p>
            <p>
              <b>URL:</b> {result.included?.[0]?.url}
            </p>
          </div>
        );
      return null;
    },
  },
};

export default mapping;
